import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { SubscriptionRoutingModule } from './subscription-routing.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SubscriptionPlanDetailsComponent } from './modals/subscription-plan-details/subscription-plan-details.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { GameDeleteConfirmationComponent } from './subscription-downgrade/modals/game-delete-confirmation/game-delete-confirmation.component';
import { PaymentCancelComponent } from './payment-cancel/payment-cancel.component';
import { MapDeleteConfirmationComponent } from './subscription-downgrade/modals/map-delete-confirmation/map-delete-confirmation.component';
import { CharacterDeleteConfirmationComponent } from './subscription-downgrade/modals/character-delete-confirmation/character-delete-confirmation.component';
import { DowngradeFeedbackComponent } from './subscription-downgrade/modals/downgrade-feedback/downgrade-feedback.component';
import { DowngradeCleanupComponent } from './subscription-downgrade/modals/downgrade-cleanup/downgrade-cleanup.component';
import { AccountCleanupWizardComponent } from './subscription-downgrade/modals/account-cleanup-wizard/account-cleanup-wizard.component';
import { MapDeleteInnerConfirmationComponent } from './subscription-downgrade/modals/map-delete-inner-confirmation/map-delete-inner-confirmation.component';

@NgModule({
  declarations: [
    PaymentSuccessComponent,
    PaymentCancelComponent,
    MapDeleteConfirmationComponent,
    CharacterDeleteConfirmationComponent,
    DowngradeFeedbackComponent,
    GameDeleteConfirmationComponent,
    DowngradeCleanupComponent,
    AccountCleanupWizardComponent,
    MapDeleteInnerConfirmationComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SubscriptionRoutingModule,
    NgxPermissionsModule.forChild({
      permissionsIsolate: false,
    }),
  ],
})
export class SubscriptionModule { }
